export default __webpack_public_path__ + "f7f670b4e34b78241f3b4e5397dda4bd.png";